import { useNavigate } from "react-router-dom";
import { FaUserTie, FaStore, FaHandshake } from "react-icons/fa";
import "../css/registerSection.css";
import { useRef } from "react";


function RegisterSection() {
  const navigate = useNavigate();

  const bookForm = (role) => {
    navigate(`/bookForm?role=${role}`);
  };

  return (
    <div className="register-section" id="register">
      <div className="register-container">
        <div className="register-header">
          <h1 className="slogan-heading">
            Where <span className="highlight">Ideas Ignite</span> and <span className="highlight">Futures Are Powered</span>
          </h1>
          <p className="event-location">Energy X Africa Conference and Exhibition is coming to Kimberley, Northern Cape</p>
          {/* <div className="event-date">
            <span>September 15 - 17, 2025</span>
          </div> */}
        </div>

        <div className="registration-options">
          <div className="option-card" onClick={() => bookForm('delegate')}>
            <div className="option-icon">
              <FaUserTie />
            </div>
            <h3>For Delegates</h3>
            <p>Join as an attendee and participate in the conference</p>
            <button className="btn-reg">Register Now</button>
          </div>

          <div className="option-card" onClick={() => bookForm('exhibitor')}>
            <div className="option-icon">
              <FaStore />
            </div>
            <h3>For Exhibitors</h3>
            <p>Showcase your products and services</p>
            <button className="btn-reg">Book Stand</button>
          </div>

          <div className="option-card" onClick={() => bookForm('sponsor')}>
            <div className="option-icon">
              <FaHandshake />
            </div>
            <h3>For Sponsors</h3>
            <p>Explore partnership opportunities</p>
            <button className="btn-reg">Sponsor Event</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterSection;